<script lang="ts">
	import clsx from 'clsx';
	import AppBarDrawerButton from './AppBarDrawerButton.svelte';

	/**
	 * The visibility of the drawer hamburger icon fot tablet and mobile
	 * devices.
	 *
	 * @default true
	 */
	export let showDrawerButton = false;

	let barHeight: number;

	const headerStyle = clsx(
		'h-[64px] md:h-[72px] border-b border-neutral-100',
		'w-full flex items-center bg-surface px-4',
	);

	const wrapperStyle = clsx(
		'mv-app-bar fixed top-0 left-0 right-0 flex flex-col',
	);
</script>

<!--
@component
The base app bar component.
- usage:

	```svelte
	<AppBar name="App name">
		<span slot="spacer">
		<span slot="back-button">
		<span slot="app-logo">

		<span slot="left">
  			The left side of the app bar
		</span>

		<span slot="right">
  			The right side of the app bar
		</span>

		<span slot="actions">
	  		The actions of the app bar (after the right slot)
		</span>

		<span slot="close-button">
	</AppBar>

	<span slot="banner">
	```
-->

<div
	style={`height: ${barHeight}px; min-height: 72px;`}
	class="flex-shrink-0" />

<div
	class="{wrapperStyle} {$$props['class'] || ''}"
	data-testid="mv-app-bar"
	bind:clientHeight={barHeight}>
	<header class={headerStyle}>
		{#if showDrawerButton}
			<span class="md:hidden">
				<AppBarDrawerButton />
			</span>
		{/if}

		<slot name="back-button" />
		<slot name="app-logo" />

		<div class="flex flex-1 items-center px-4">
			<div class="hidden md:block">
				<div class="flex space-x-4">
					<span>
						<slot name="left" />
					</span>
				</div>
			</div>
		</div>

		<slot name="right" />
		<slot name="actions" />
		<slot name="close-button" />
	</header>

	<div class="mv-app-banner flex">
		<slot name="banner" />
	</div>
</div>
